// extracted by mini-css-extract-plugin
module.exports = {"header_container":"imagemap_header_container__19LB9","labels_container":"imagemap_labels_container__cmymG"};